import { render, staticRenderFns } from "./ConnectionStats.vue?vue&type=template&id=61e2f2e6&scoped=true&"
import script from "./ConnectionStats.vue?vue&type=script&lang=js&"
export * from "./ConnectionStats.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionStats.vue?vue&type=style&index=0&id=61e2f2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2f2e6",
  null
  
)

export default component.exports